/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Recipe_CookedInputs */

const en_recipe_cooked = /** @type {(inputs: Recipe_CookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cooked ${i?.count}×`)
};

const de_recipe_cooked = /** @type {(inputs: Recipe_CookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}× gekocht`)
};

/**
* | output |
* | --- |
* | "Cooked {count}×" |
*
* @param {Recipe_CookedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_cooked = /** @type {((inputs: Recipe_CookedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_CookedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_cooked(inputs)
	return en_recipe_cooked(inputs)
});